import React from 'react';
import 'antd/dist/antd.css';
import { Layout, Menu, Icon } from 'antd';

import '../styles/Dashboard.scss';
import TransactionTable from './TransactionPage';
import Analytics from './Analytics';

const { Header, Sider, Content } = Layout;

class Dashboard extends React.Component {
    state = {
        collapsed: false,
        selected: 'transactions',
        defaultComponent: '1'
    };

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed
        });
    };

    selectComponent(key) {
        switch (key.key) {
            case "transactions":
                this.setState({
                    selected: 'transactions'
                });
                break;
            case "analytics":
                this.setState({
                    selected: 'analytics'
                });
                break;
            default:
                return;
        }
    }

    render() {

        const { selected } = this.state;

        return (
            <Layout className="layout-style">
                <Sider trigger={null} collapsible collapsed={this.state.collapsed}>
                    <div className="logo"></div>
                    <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']} onClick={(key) => this.selectComponent(key)}>
                        <Menu.Item key="transactions">
                            <Icon type="table" />
                            <span>QR Transactions</span>
                        </Menu.Item>
                        <Menu.Item key="analytics" disabled>
                            <Icon type="fund" />
                            <span>Analytics</span>
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout>
                    <Header style={{ background: '#fff', padding: 0 }}>
                        <Icon
                            className="trigger"
                            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.toggle}
                        />
                        QR TRANSACTIONS
                    </Header>
                    <Content
                        style={{
                            margin: '24px 16px',
                            padding: 24,
                            background: '#fff',
                            minHeight: 280,
                        }}
                    >
                        {selected === "transactions" &&
                            <TransactionTable />
                        }

                        {selected === "analytics" &&
                            <Analytics />
                        }
                    </Content>
                </Layout>
            </Layout>
        );
    }
}



export default Dashboard;